/* Doodle Dreams: design-picker presentation only; price/cart variant logic remains in Shopify theme. */
(function(){
  if (window.__ddStyleUiInstalled) return;
  window.__ddStyleUiInstalled=true;
  // Only an explicit change to the Starter/Duo dropdown may update its value.
  // Shopify asynchronously replaces variant-row HTML when the top style pill changes;
  // retain the shopper's dropdown selections across that replacement.
  const userPickerSelections = new WeakMap();
  function dropdownKey(select){
    const list=select.closest('[id^="option-2-variant-"]');
    if(list) return 'duo:' + Array.from(list.querySelectorAll('select.dd-style-dropdown')).indexOf(select);
    return 'starter';
  }
  function saveSelection(select){
    const root=select.closest('product-info');
    if(!root) return;
    let entries=userPickerSelections.get(root);
    if(!entries){entries=new Map();userPickerSelections.set(root,entries);}
    entries.set(dropdownKey(select),select.value);
    select.dataset.ddUserPicked='true';
  }
  function restoreSelections(root){
    const info=root?.matches?.('product-info')?root:root?.closest?.('product-info');
    if(!info) return;
    const values=userPickerSelections.get(info);
    info.querySelectorAll('.dd-bundle-options select.dd-style-dropdown').forEach(function(select){
      const saved=values?.get(dropdownKey(select));
      if(saved !== undefined && Array.from(select.options).some(o=>o.value===saved && !o.disabled)){
        select.value=saved;
      } else if (!select.dataset.ddUserPicked) {
        // Never inherit an unrelated style from the top product buttons.
        select.value='';
      }
      updateThumb(select);
    });
    // Preserve the Starter's own Style/Size dropdown values as well (Shopify replaces row HTML).
    info.querySelectorAll('.dd-pyj-starter-row select').forEach(function(select){
      const role=select.classList.contains('dd-pyj-starter-size')?'size':'style';
      const saved=values?.get('pyj-starter:'+role);
      if(saved!==undefined && Array.from(select.options).some(o=>o.value===saved))select.value=saved;
    });
    // Preserve independent pyjama Duo style/size choices through theme variant refreshes.
    info.querySelectorAll('.dd-pyj-duo-row select').forEach(function(select){
      const row=select.closest('.dd-pyj-duo-row');
      const role=select.classList.contains('dd-pyj-size-select')?'size':'style';
      const saved=values?.get('pyj:'+row?.dataset.ddPyjIndex+':'+role);
      if(saved!==undefined && Array.from(select.options).some(o=>o.value===saved))select.value=saved;
    });
    info.querySelectorAll('.dd-pyj-starter-style, .dd-pyj-style-select').forEach(updatePyjamaThumb);
  }
  window.ddStarterVariantChange=function(event){
    const select=event.target;
    const root=select.closest('product-info');
    const pill=root?.querySelector('.dd-style-pills');
    const chosen=select.selectedOptions?.[0]?.textContent?.trim();
    const input=Array.from(pill?.querySelectorAll('input[type="radio"]')||[]).find(el=>el.value.trim()===chosen);
    if(input){
      if(!input.checked){ input.checked=true; input.dispatchEvent(new Event('change',{bubbles:true})); }
      else {
        const hidden=root.querySelector('product-form input[name="id"]');
        if(hidden){hidden.value=select.value;hidden.dataset.selectedId=select.value;}
      }
    }else{
      const hidden=root?.querySelector('product-form input[name="id"]');
      if(hidden){hidden.value=select.value;hidden.dataset.selectedId=select.value;}
    }
    // A single-item Starter selection must not retain components from a previous Duo.
    const extra=root?.querySelector('.product-form__multiple-variant-ids');
    if(extra) extra.innerHTML='';
  };
  // A blank Starter / Duo / Doodle Special selection should never replace the
  // product's first gallery photo. Once the shopper explicitly chooses a style,
  // show that variant's attached media without changing Shopify's image order.
  function showChosenVariantMedia(select){
    if (!select?.value) return;
    const root=select.closest('product-info');
    if (!root) return;
    const script=root.querySelector('variant-radios.dd-style-pills script[type="application/json"]');
    if (!script) return;
    let variants;
    try { variants=JSON.parse(script.textContent); } catch (_) { return; }
    if (!Array.isArray(variants)) return;
    let variant;
    let chosenGenderMediaId = null;
    if (select.matches('.dd-style-dropdown')) {
      variant=variants.find(v => String(v.id)===select.value);
    } else if (select.matches('.dd-special-design-select')) {
      variant=variants.find(v => v.title===select.value || v.option1===select.value);
    } else if (select.matches('.dd-pyj-starter-style, .dd-pyj-starter-size, .dd-pyj-style-select, .dd-pyj-size-select')) {
      const row=select.closest('.dd-pyj-starter-row, .dd-pyj-duo-row');
      const style=row?.querySelector('.dd-pyj-starter-style, .dd-pyj-style-select')?.value;
      const size=row?.querySelector('.dd-pyj-starter-size, .dd-pyj-size-select')?.value;
      if (!style) return;
      const stylePicker=row?.querySelector('.dd-pyj-starter-style, .dd-pyj-style-select');
      // The selected gender determines the pyjama gallery picture, regardless
      // of older Shopify variant image attachments or the chosen size.
      chosenGenderMediaId=style==='Girl' ? stylePicker?.dataset.ddGirlMedia
        : style==='Boy' ? stylePicker?.dataset.ddBoyMedia : null;
      variant=variants.find(v => v.option1===style && (!size || v.option2===size));
    }
    const mediaId=chosenGenderMediaId || variant?.featured_media?.id;
    if (!mediaId) return;
    const section=root.dataset.section;
    if (!section) return;
    document.querySelectorAll('[id^="MediaGallery-'+section+'"]')
      .forEach(gallery => {
        if (typeof gallery.setActiveMedia !== 'function') return;
        const id=section+'-'+mediaId;
        if (gallery.querySelector('[data-media-id="'+id+'"]')) gallery.setActiveMedia(id,false);
      });
  }
  function updateThumb(select){
    if(!select || !select.matches('.dd-style-dropdown')) return;
    const img=select.closest('.dd-style-option-row')?.querySelector('.dd-style-thumb img');
    if (!img) return;
    // Keep the product's first media image until this specific picker has a choice.
    if (!img.dataset.ddFirstImage) img.dataset.ddFirstImage=img.getAttribute('src');
    const chosen=select.selectedOptions?.[0];
    img.src=select.value && chosen?.dataset.styleImage ? chosen.dataset.styleImage : img.dataset.ddFirstImage;
    img.alt=select.value ? (chosen?.textContent?.trim() || '') : '';
  }
  function updatePyjamaThumb(select){
    if (!select?.matches('.dd-pyj-starter-style, .dd-pyj-style-select')) return;
    const img=select.closest('.dd-style-option-row')?.querySelector('.dd-style-thumb img');
    if (!img) return;
    if (!img.dataset.ddFirstImage) img.dataset.ddFirstImage=img.getAttribute('src');
    const image=select.value==='Girl' ? select.dataset.ddGirlImage
      : select.value==='Boy' ? select.dataset.ddBoyImage : null;
    img.src=image || img.dataset.ddFirstImage;
    img.alt=select.value || '';
  }
  function updateSpecialThumb(select){
    if (!select?.matches('.dd-special-design-select')) return;
    // Each of the four Doodle Special rows has its own independent preview.
    const img=select.closest('.dd-special-design-row')?.querySelector('.dd-special-style-thumb img');
    if (!img) return;
    if (!img.dataset.ddFirstImage) img.dataset.ddFirstImage=img.getAttribute('src');
    const chosen=select.selectedOptions?.[0];
    img.src=select.value && chosen?.dataset.image ? chosen.dataset.image : img.dataset.ddFirstImage;
    img.alt=select.value ? (chosen?.textContent?.trim() || '') : '';
  }
  function syncLegends(root){
    (root||document).querySelectorAll('.dd-style-pills__fieldset').forEach(function(field){
      const selected=field.querySelector('input[type="radio"]:checked');
      const legend=field.querySelector('.dd-style-pills__chosen');
      if(selected && legend) legend.textContent=selected.value;
    });
  }
  function immediateVariantDetails(input){
    const picker=input.closest('variant-radios.dd-style-pills');
    const info=picker?.closest('product-info');
    if(!picker || !info) return;
    const data=picker.querySelector('script[type="application/json"]');
    if(!data) return;
    let variants;
    try{variants=JSON.parse(data.textContent)}catch{return;}
    const options=Array.from(picker.querySelectorAll('fieldset')).map(field=>field.querySelector('input:checked')?.value);
    const variant=variants.find(item=>item.options?.every((v,i)=>v===options[i]));
    if(!variant) return;
    // Never fake bundle prices; this updates only the single-product variant display.
    const price=info.querySelector('[id^="price-"] .price');
    if(price){
      const format=(c)=>'R '+(Number(c)/100).toLocaleString('en-ZA',{minimumFractionDigits:2,maximumFractionDigits:2});
      price.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(el=>el.textContent=format(variant.price));
      const compare=price.querySelector('.price__compare-price .price-item');
      if(compare && variant.compare_at_price) compare.textContent=format(variant.compare_at_price);
      price.classList.toggle('price--on-sale',!!(variant.compare_at_price>variant.price));
    }
  }
  function compactLeadingLines(root){
    (root||document).querySelectorAll('.product__info-container > .product__description.rte').forEach(function(description){
      if(description.dataset.ddDescriptionDone) return;
      description.dataset.ddDescriptionDone='1';
      // The first two top-level paragraphs already receive the bold styling via CSS.
      // Some merchants use explicit line breaks in the first paragraph instead.
      const first=description.querySelector(':scope > p:first-of-type');
      if(!first || first.querySelector('p,ul,ol,table') || !first.querySelector('br')) return;
      const paragraphs=description.querySelectorAll(':scope > p');
      if(paragraphs.length>=2) return;
      let count=0;
      for(const child of Array.from(first.childNodes)){
        if(count>=2) break;
        if(child.nodeName==='BR'){count++;continue;}
        if(child.nodeType===3 && child.textContent.trim()){
          const mark=document.createElement('span');mark.className='dd-description-intro-line';
          first.replaceChild(mark,child);mark.appendChild(child);
        }
      }
    });
  }
  function formatBenefitMarkers(root){
    (root||document).querySelectorAll('.product__info-container > .product__description.rte').forEach(function(description){
      // Convert only opening arrow glyphs in description benefit lines. Never edit stored product data.
      description.querySelectorAll('li, p').forEach(function(line){
        if(line.classList.contains('dd-benefit-symbol-done')) return;
        const walker=document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
        let first=null;
        while(walker.nextNode()){
          const node=walker.currentNode;
          if(node.textContent.trim()){first=node;break;}
        }
        if(!first) return;
        const match=first.textContent.match(/^(\s*)[▸▹▶►➤➢▻‣›→❯]\s*/u);
        if(!match) return;
        first.textContent=first.textContent.slice(match[0].length);
        const tick=document.createElement('strong');
        tick.className='dd-benefit-tick';
        tick.textContent='◆ ';
        first.parentNode.insertBefore(tick,first);
        line.classList.add('dd-benefit-symbol-done');
      });
    });
  }
  function initialize(root){
    (root||document).querySelectorAll('.dd-style-dropdown').forEach(function(select){
      if (!select.dataset.ddInitialized) {
        select.dataset.ddInitialized='true';
        // Avoid browser/theme-editor restoration silently choosing the first design.
        if (!select.dataset.ddUserPicked) select.value='';
      }
      updateThumb(select);
    });
    (root||document).querySelectorAll('.dd-special-design-select').forEach(updateSpecialThumb);
    (root||document).querySelectorAll('.dd-pyj-starter-style, .dd-pyj-style-select').forEach(updatePyjamaThumb);
    syncLegends(root);
    compactLeadingLines(root);
    formatBenefitMarkers(root);
  }
  document.addEventListener('change',function(event){
    if(event.target.matches('.dd-style-dropdown, .dd-special-design-select, .dd-pyj-starter-style, .dd-pyj-starter-size, .dd-pyj-style-select, .dd-pyj-size-select')){
      showChosenVariantMedia(event.target);
    }
    if(event.target.matches('.dd-special-design-select')){
      updateSpecialThumb(event.target);
    }
    if(event.target.matches('.dd-pyj-starter-style, .dd-pyj-style-select')){
      updatePyjamaThumb(event.target);
    }
    if(event.target.matches('.dd-style-dropdown')){
      saveSelection(event.target);
      updateThumb(event.target);
    }
    if(event.target.matches('.dd-bundle-options .dd-pyj-starter-row select')){
      const select=event.target, root=select.closest('product-info');
      if(root){
        let entries=userPickerSelections.get(root);
        if(!entries){entries=new Map();userPickerSelections.set(root,entries);}
        const role=select.classList.contains('dd-pyj-starter-size')?'size':'style';
        entries.set('pyj-starter:'+role,select.value);
      }
    }
    if(event.target.matches('.dd-bundle-options .dd-pyj-duo-row select')){
      const select=event.target, root=select.closest('product-info');
      if(root){
        let entries=userPickerSelections.get(root);
        if(!entries){entries=new Map();userPickerSelections.set(root,entries);}
        const row=select.closest('.dd-pyj-duo-row');
        const role=select.classList.contains('dd-pyj-size-select')?'size':'style';
        entries.set('pyj:'+row?.dataset.ddPyjIndex+':'+role,select.value);
      }
    }
    if(event.target.matches('.dd-bundle-options input[name="quantity"]')){
      // Theme's existing quantity reset runs on the same event; reflect any new select values.
      window.setTimeout(function(){initialize(event.target.closest('product-info') || document);},0);
    }
    if(event.target.matches('.dd-style-pills input[type="radio"]')){
      immediateVariantDetails(event.target);
      syncLegends(event.target.closest('.dd-style-pills'));
      // Deliberately DO NOT update the Starter or Duo dropdown here.
      // Style pills control the gallery/current product variant, not bundle choices.
    }
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initialize(document);});
  else initialize(document);
  document.addEventListener('shopify:section:load',function(e){initialize(e.target);});
  function listenForVariantRefresh(){
    if(typeof subscribe!=='function' || typeof PUB_SUB_EVENTS==='undefined' || !PUB_SUB_EVENTS.variantChange) return;
    subscribe(PUB_SUB_EVENTS.variantChange,function(e){
      const sectionId=e?.data?.sectionId;
      const root=sectionId ? document.querySelector('product-info[data-section="'+sectionId+'"]') : null;
      if(root) restoreSelections(root);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',listenForVariantRefresh,{once:true});
  else listenForVariantRefresh();
})();
